import { Tooltip, TooltipContent, TooltipTrigger } from '@optools/components/ui/tooltip';
import { TriangleAlert } from 'lucide-react';

export interface ProfileComparisonProps {
  cachedValue: string | null | undefined | number;
  profileValue: string | null | undefined | number;
}

const WarningTooltip = ({ text }: { text: string }) => {
  return (
    <Tooltip>
      <TooltipTrigger>
        <TriangleAlert className="size-4 stroke-amber-400" />
      </TooltipTrigger>
      <TooltipContent className="text-xs">{text}</TooltipContent>
    </Tooltip>
  );
};

export function ProfileComparison({ cachedValue, profileValue }: ProfileComparisonProps) {
  return (
    <div className="flex gap-2">
      {cachedValue !== profileValue && (
        <WarningTooltip text="Cached and Profile values do not match" />
      )}
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2" data-testid="profile-value">
          <p className="text-xs font-bold">Profile Value:</p>
          <p className="text-xs font-normal">{profileValue ?? 'null'}</p>
        </div>
        <div className="flex items-center gap-2" data-testid="cached-value">
          <p className="text-xs font-bold">Cached Value:</p>
          <p className="text-xs font-normal">{cachedValue ?? 'null'}</p>
        </div>
      </div>
    </div>
  );
}
